<template>
  <div class="page">
    <!-- 广告图 -->
    <Banner />
    <!-- 溯源 -->
    <Source />
    <!-- 运用 -->
    <Application />
    <!-- 核心 -->
    <Core />
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Source from './components/source.vue'
import Application from './components/application.vue'
import Core from './components/core.vue'
export default {
  components: {
    Banner,
    Source,
    Application,
    Core
  },
  created() {
    console.log('产品介绍')
  }
}
</script>

<style lang="scss" scoped></style>
